import { GET, POST } from './api'
import { ReadObject, SaveObject } from './storage'

export const DoRegister = async params => {
	return await POST(`/auth/local/register`, params)
}

export const DoLogin = async params => { 
	const response = await POST(`/auth/local`, params)
	if (response?.jwt) {
		await SaveObject('authentication', response)
	}
	return response
}

export const DoLogout = async () => {
	await SaveObject('authentication', {})
	return true
} 
  
export const DoForgotPassword = async params => {
	return await POST(`/auth/forgot-password`, params)
}

export const DoResetPassword = async params => {
	return await POST(`/auth/reset-password`, params)
}

export const IsLogged = async () => {
	const authentication = await ReadObject('authentication')
	return authentication?.jwt
}

export const ReadMe = async () => {
	return await GET(`/me?populate[0]=active_profile&populate[active_profile][populate][0]=picture`, true)
}  

export const ReadTVCode = async () => {
	return await GET(`/generate-code`, true)
}  

export const ReadPremiumPlans = async () => {
	return await GET(`/premium`)
}  

export const ReadAbout = async () => {
	return await GET(`/information`)
}  